// Order matters. These values are displayed in order of keys on the Details page.
import { IconId } from '@drone-js/core';

export enum KeyInfoType {
    nonRefundable = 'nonRefundable',
    freeCancellation = 'freeCancellation',
    duration = 'duration',
    instantConfirmation = 'instantConfirmation',
    pickUp = 'pickUp',
    mobileTicket = 'mobileTicket',
    printTicket = 'printTicket',
}

export const KeyInfoIcon: Record<KeyInfoType, IconId> = {
    nonRefundable: 'fill.symbol.restricted',
    freeCancellation: 'fill.brand.easycancel',
    duration: 'fill.symbol.time',
    instantConfirmation: 'fill.symbol.circle-check',
    pickUp: 'fill.transportation.car',
    mobileTicket: 'fill.electrics.cellphone',
    printTicket: 'fill.electrics.printer',
};

export interface KeyInfoItem {
    type: KeyInfoType;
    text: string;
    icon: IconId;
}
